import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { checkPassword } from '@blade-sxp/account/api/setting';
import password from '@blade-sxp/account/lang/password';
import { validatePassword } from '@blade-sxp/account/utils/validate';
import { AccountModule } from '@blade-sxp/account/store/account';
let default_1 = class extends Vue {
    password = '';
    newPassword = '';
    comfirmNewPassword = '';
    mounted() { }
    checkPassword() {
        let data = {
            new_password: this.newPassword,
            origin_password: this.password,
            password_check: this.comfirmNewPassword,
        };
        checkPassword(data)
            .then((res) => {
            this.$message({
                message: this.$t('changeSuccess').toString(),
                type: 'success',
            });
        })
            .catch((err) => {
            this.$message({
                message: err,
                type: 'error',
            });
        });
    }
    async save() {
        if (!this.password) {
            return this.$message.error(this.$t('enterPassword').toString());
        }
        if (!this.newPassword) {
            return this.$message.error(this.$t('enterNewPassword').toString());
        }
        if (!this.comfirmNewPassword) {
            return this.$message.error(this.$t('ConfirmPassword').toString());
        }
        if (this.comfirmNewPassword !== this.newPassword) {
            return this.$message.error(this.$t('twoPassword').toString());
        }
        const accountName = await AccountModule.getUserName();
        const msg = validatePassword(this.newPassword, accountName);
        if (msg) {
            return this.$message.error(this.$t(msg).toString());
        }
        this.checkPassword();
    }
};
default_1 = __decorate([
    Component({
        name: 'record',
        i18n: {
            messages: {
                'en-us': {
                    changePassword: 'Change Password',
                    password: 'Password',
                    NewPassword: 'New Password',
                    ConfirmPassword: 'Please re-enter the new password',
                    enterPassword: 'Please enter your password',
                    enterNewPassword: 'Please enter your new password',
                    twoPassword: 'Two password entries are inconsistent',
                    passWordLength: 'Password length is 8 to 64 bits',
                    changeSuccess: 'Successfully change password',
                    passwordStyle: 'Password must contain three types of numeric uppercase letters lowercase letters or special characters',
                },
                zh: {
                    changePassword: '修改密码',
                    password: '密码',
                    NewPassword: '新密码',
                    ConfirmPassword: '请重新输入新密码',
                    enterPassword: '请输入您的密码',
                    enterNewPassword: '请输入您的新密码',
                    twoPassword: '两次密码输入不一致',
                    passWordLength: '密码长度为8至64位',
                    passwordStyle: '密码必须包含三种类型(数字，大写字母，小写字母或特殊字符)',
                    changeSuccess: '修改密码成功',
                },
            },
            sharedMessages: password
        },
    })
], default_1);
export default default_1;
